import { companyProfileEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiUserHandler } from "@/services/shared";
import type { ApiUserType, AuthUserType, UpdateCompanyProfileRequestType } from "@/types";

export const updateCompanyProfileHandler = async ({
    companyName,
    email,
    name,
    password,
    passwordConfirmation,
    phone,
}: UpdateCompanyProfileRequestType): Promise<{
    message: string,
    user: AuthUserType,
}> => {
    const payload: UpdateCompanyProfileRequestType = {
        companyName: companyName,
        name: name,
        phone: phone,
    };

    if (email) payload.email = email;

    if (password) {
        payload.password = password;

        payload.passwordConfirmation = passwordConfirmation;
    }

    const response = await axiosClient.put<{
        message: string,
        user: ApiUserType,
    }>(
        companyProfileEndpoints.base,
        payload,
    );

    return {
        message: response.data.message,
        user: transformApiUserHandler(response.data.user),
    };
};
